import ReactDOM from"react-dom";export var unstable_batchedUpdates=ReactDOM.unstable_batchedUpdates;